import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';

export default function VerifyEmail() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    fetch(`/api/auth/verify-email/${token}`)
      .then(res => {
        if (res.ok || res.redirected) {
          setStatus('success');
          setTimeout(() => navigate('/login?verified=true'), 2000);
        } else {
          setStatus('error');
        }
      })
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="card text-center max-w-md w-full space-y-4">
        {status === 'loading' && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto" />
            <p className="text-gray-500">Verifying your email...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-14 h-14 text-green-500 mx-auto" />
            <h2 className="text-2xl font-bold text-gray-900">Email verified!</h2>
            <p className="text-gray-500">Redirecting you to sign in...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-14 h-14 text-red-500 mx-auto" />
            <h2 className="text-2xl font-bold text-gray-900">Verification failed</h2>
            <p className="text-gray-500">This link may be invalid or already used.</p>
            <button onClick={() => navigate('/login')} className="btn-primary px-8">Go to Sign In</button>
          </>
        )}
      </div>
    </div>
  );
}
